import React, { useState, useMemo, useEffect, useRef } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
  Cell,
} from "recharts";
import {
  deleteTemporaryFilters,
  setFiltersToOtherSheets,
  getL1SheetProperty,
  getL2SheetProperty,
  setWorkbookProperty,
  getWorkbookProperty,
  updateLevel2Properties,
  removeLevel2Properties,
  setLevel2Properties,
} from "../../../features/reduxworkbook/WorkbookSlice";
import { useSelector, useDispatch } from "react-redux";
import { nanoid } from "@reduxjs/toolkit";
import { lineTransformData } from "../Utils/lineTransformData";
import { getColourSchemeByID } from "../../../Colors/ColorPalettes";
import {
  getSheetControls,
  setSheetControls,
} from "../../../features/reduxworkbook/WorkbookControllingSlice";
import { formatNumber } from "../Utils/FormatNumbers";
import { sortData } from "../Utils/SortData";
import {
  dispatchSortValues,
  stackBarChartColorArray,
  stackedBarChartPosition,
  calculateYforXaxisLabel,
} from "../Utils/ChartsFunctions";
import { CalculateAction, handleClicked } from "../../actions/Action";
import { CustomTooltip } from "../Custom/CustomTooltipContent";
import { handleHeirarchy } from "../Utils/HandleHeirarchy";
import { calculateAxis, rightAxisVisible } from "../Utils/calculateAxis";
import { useNavigate } from "react-router-dom";
import { CustomLegend } from "../Custom/CustomLegendContent";

const StackedBarChartComp = ({
  Data,
  Sheetid,
  rowKeys: rawRowKeys,
  valueKeys = [],
  groupByKeys: rawGroupByKeys,
  toolTipKeys,
  sortProperties,
  isAnimataionOff,
  vizType,
  filters: filterArray,
  dataSourceID,
}) => {
  let timer;

  const reduxActiveBarIndex = useSelector(
    getSheetControls({ Sheetid: Sheetid, key: "activeBarIndex" })
  );
  // console.log(reduxActiveBarIndex);

  const reduxStackActiveIndex = useSelector(
    getSheetControls({ Sheetid: Sheetid, key: "stackActiveIndex" })
  );
  const reduxClickedValues = useSelector(
    getSheetControls({ Sheetid: Sheetid, key: "clickedValues" })
  );

  const rowKeys = rawRowKeys.map((item) => item.responseKey);
  const [activeBarIndex, setActiveBarIndex] = useState(
    reduxActiveBarIndex !== undefined ? reduxActiveBarIndex : []
  );
  // // console.log(activeBarIndex);
  const isRightAxisVisible = rightAxisVisible({ valueKeys });
  // console.log(isRightAxisVisible);

  const [stackActiveIndex, setStackActiveIndex] = useState(
    reduxStackActiveIndex !== undefined ? reduxStackActiveIndex : []
  );
  const [targetSheetid, setTargetSheetid] = useState(null);
  const [hoverIndex, setHoverIndex] = useState();
  // // console.log(hoverIndex);
  const [stackHoverIndex, setStackHoverIndex] = useState();
  const [clickedValues, setClickedValues] = useState(
    reduxClickedValues !== undefined
      ? reduxClickedValues
      : {
          barClickedCaption: [],
          stackClickedCaption: [],
        }
  );
  // console.log(toolTipKeys);
  // console.log(stackActiveIndex);
  // console.log(activeBarIndex);
  const [clickTimeoutState, setClickTimeoutState] = useState(null);
  const [longestLabelWidth, setLongestLabelWidth] = useState(0);
  // console.log(longestLabelWidth);

  // const leftMargin = Math.ceil(longestLabelWidth);
  // // console.log(leftMargin);

  const SufixPrefix = { ...valueKeys.map((item) => item.numberFormat)[0] };
  const dispatch = useDispatch();
  const navigate = useNavigate(); // For URL navigation

  const groupByKeys = rawGroupByKeys.map((item) => item.responseKey);

  const customizationObject = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "customization")
  );
  const getOnClickProperties = useSelector((state) => {
    return getL2SheetProperty(state, Sheetid, "actions", "onClick");
  });
  const getOnDoubleClickProperties = useSelector((state) =>
    getL2SheetProperty(state, Sheetid, "actions", "onDoubleClick")
  );
  const sheetsArray = useSelector((state) =>
    getWorkbookProperty(state, "sheets")
  );
  const hierarchy =
    useSelector((state) => getWorkbookProperty(state, "hierarchy")) || [];
  const workbookId =
    useSelector((state) => getWorkbookProperty(state, "_id")) || [];
  const workbookType =
    useSelector((state) => getWorkbookProperty(state, "type")) || [];
  // // console.log(workbookType);

  const targetSheetQuery = useSelector((state) =>
    targetSheetid !== null
      ? getL1SheetProperty(state, targetSheetid, "query")
      : null
  );

  // console.log(targetSheetQuery);

  const handleTargetSheetQuery = (sheetid) => {
    // console.log(sheetid);
    setTargetSheetid(sheetid);
  };

  const {
    colorSchemeid,
    barSize,
    isLabelVisible,
    labelPosition,
    labelFontSize,
    labelFontColor,
    labelRotate,
    isStackbarVisible,
    isTransposeVisible,
    isGridVisible,
    isLegendVisible,
    legendAlign,
    legendLayout,
    legendVerticalAlign,
    isAxeslabelVisible,
    colorMapping,
    legendFontColor,
    isLegendBold,
    isTitleBold,
    Title,
    isTileVisible,
    TitleFontColor,
    TitleSize,
    valueAlign,
  } = customizationObject;
  // console.log(isLegendBold);

  // // console.log(getOnClickProperties);
  // // console.log(getOnDoubleClickProperties);
  // // console.log(colorSchemeid);
  // // console.log(getColourSchemeByID(colorSchemeid));

  const COLORS = getColourSchemeByID(colorSchemeid)
    ? getColourSchemeByID(colorSchemeid).colors
    : [];
  const {
    table: transformedData,
    lines: uniqueColumnValues,
    transformedTooltipKeys,
  } = useMemo(() => {
    return lineTransformData(
      Data,
      rawRowKeys,
      rawGroupByKeys,
      valueKeys,
      toolTipKeys
    );
  }, [Data, rawGroupByKeys, rawRowKeys, valueKeys, toolTipKeys]);
  // console.log("transformedData",transformedData);

  const newArray =
    uniqueColumnValues.length && valueKeys.length
      ? [
          ...uniqueColumnValues,
          ...valueKeys.map((obj) => `Total ${obj.responseKey}`),
        ]
      : [];
  useEffect(() => {
    if (rawGroupByKeys.length) {
      // console.log("hi");
      dispatchSortValues({
        newArray,
        dispatch,
        setSheetControls,
        Sheetid,
      });
    }
  }, [rawGroupByKeys]);
  const sorteData = sortProperties.length
    ? sortData({
        transformedData,
        sortProperties,
        rawRowKeys: rawRowKeys,
        rawGroupByKeys: rawGroupByKeys,
        requiredArray: rawGroupByKeys,
      })
    : transformedData;
  // console.log(sorteData);

  const xa = rawGroupByKeys[0];
  const yb = valueKeys[0];
  const ybiax = valueKeys[1];
  const yAxisResponseKey = xa?.rename;
  const xAxisCaption = yb?.caption;
  const ybiaXialCaption = ybiax?.caption;
  // console.log(yAxisResponseKey, xAxisCaption, ybiaXialCaption);

  // find data, index
  let whatShouldDispatch;
  let groupResponseKey =
    rawGroupByKeys.length === 1 ? rawGroupByKeys[0].responseKey : undefined;
  const nanoId = nanoid();

  const handleClickEvent = ({
    hoverIndex,
    barIndex,
    barClickedValue,
    stackedIndex,
    stackClickedValue,
    event,
  }) => {
    // console.log(getOnClickProperties?.action);
    // console.log(rawRowKeys[0]);
    // console.log(rawGroupByKeys[0]);
    // // console.log(getOnDoubleClickProperties);

    if (hoverIndex === null) {
      if (rawRowKeys.length === 0) {
        // console.log("clickedOutside and stack is empty");
        whatShouldDispatch = "xAxisValue";
      } else {
        // console.log("clickedOutside and stack is not empty");
        whatShouldDispatch = "xAxisValue";
      }
    } else {
      if (rawRowKeys.length === 0) {
        // console.log("clickedInside and stack is empty");
        whatShouldDispatch = "xAxisValue";
      } else {
        // console.log("clickedInside and stack is not empty");
        whatShouldDispatch = "xAxisValue&StackValue";
      }
    }
    // console.log(whatShouldDispatch);
    if (!getOnClickProperties?.action && !getOnDoubleClickProperties?.action) {
      // console.log("default filter applied");
      handleClicked({
        data: null,
        index: null,
        event: event,
        requiredArray: rawGroupByKeys,
        hoverIndex,
        dispatch,
        deleteTemporaryFilters,
        setFiltersToOtherSheets,
        Sheetid,
        clickedCaption: null,
        setClickedCaption: null,
        activeIndex: null,
        setActiveIndex: null,
        activeBarIndex,
        setActiveBarIndex,
        vizType,
        rawRowKeys,
        whatShouldDispatch,
        barIndex,
        stackedIndex,
        barClickedValue,
        stackClickedValue,
        stackActiveIndex,
        setStackActiveIndex,
        activeBarIndex,
        setActiveBarIndex,
        clickedValues,
        setClickedValues,
        setWorkbookProperty,
        filterArray,
        dataSourceID,
      });
    } else {
      if (
        (getOnClickProperties?.action === "Hierarchy" && rawGroupByKeys[0]) ||
        (getOnClickProperties?.action === "Hierarchy" &&
          rawRowKeys[0] &&
          rawGroupByKeys[0])
      ) {
        const rowCurrentValue =
          rawRowKeys[0] !== undefined && rawRowKeys[0]["rename"];
        const groupCurrentValue = rawGroupByKeys[0]["rename"];
        let groupFilterItemIs,
          rowFilterItemIs,
          isGroupHierarchyLastItemExist,
          isRowHierarchyLastItemExist,
          groupIsExpandable,
          rowIsExpandable;
        groupFilterItemIs = {
          columnName: rawGroupByKeys[0].columnName,
          dataType: rawGroupByKeys[0].dataType,
          uuid: rawGroupByKeys[0].uuid,
          rename: rawGroupByKeys[0].rename,
          sourceSheetId: Sheetid,
          nanoId: nanoId,
          selectedFilterValues: [barClickedValue],
          selectedOperator: "IN",
          filterType: "temporary",
          format: null,
          dataSourceID,
        };
        if (rawRowKeys[0]) {
          rowFilterItemIs = {
            columnName: rawRowKeys[0].columnName,
            dataType: rawRowKeys[0].dataType,
            uuid: rawRowKeys[0].uuid,
            rename: rawRowKeys[0].rename,
            sourceSheetId: Sheetid,
            nanoId: nanoId,
            selectedFilterValues: [stackClickedValue],
            selectedOperator: "IN",
            filterType: "temporary",
            format: null,
            dataSourceID,
          };
        }

        const rowHierarchy = rowCurrentValue
          ? hierarchy.find((item) =>
              item.hierarchyArray.find((arr) => arr.rename === rowCurrentValue)
            )
          : null;
        const groupHierarchy = groupCurrentValue
          ? hierarchy.find((item) =>
              item.hierarchyArray.find(
                (arr) => arr.rename === groupCurrentValue
              )
            )
          : null;
        rowIsExpandable =
          rowHierarchy !== undefined && rowHierarchy !== null ? true : false;
        groupIsExpandable =
          groupHierarchy !== undefined && groupHierarchy !== null
            ? true
            : false;
        isGroupHierarchyLastItemExist =
          groupHierarchy !== undefined &&
          groupHierarchy.hierarchyArray[
            groupHierarchy.hierarchyArray.length - 1
          ]["rename"] === groupCurrentValue;
        isRowHierarchyLastItemExist =
          rowHierarchy !== undefined &&
          rawRowKeys[0] &&
          rowHierarchy.hierarchyArray[rowHierarchy.hierarchyArray.length - 1][
            "rename"
          ] === rowCurrentValue;
        if (clickTimeoutState) {
          clearTimeout(clickTimeoutState);
          setClickTimeoutState(null);
          // console.log("double clicked");
          handleHeirarchy({
            headerId: groupCurrentValue,
            foundHierachy: groupHierarchy,
            requiredArray: [],
            dispatch: dispatch,
            functionToAddAndUpdate: updateLevel2Properties,
            functionToRemove: removeLevel2Properties,
            Sheetid: Sheetid,
            vizType: vizType,
            functionWillBe: "replaceItemWithNextItem",
            groupHierarchy,
            rowHierarchy,
            rowCurrentValue,
            groupCurrentValue,
            rowIsExpandable,
            groupIsExpandable,
          });
          if (groupIsExpandable && !isGroupHierarchyLastItemExist) {
            dispatch(
              setLevel2Properties({
                reduxKey: "filters",
                Sheetid,
                parentKey: "query",
                value: groupFilterItemIs,
                itemInArray: true,
              })
            );
          }
          if (rowIsExpandable && !isRowHierarchyLastItemExist) {
            dispatch(
              setLevel2Properties({
                reduxKey: "filters",
                Sheetid,
                parentKey: "query",
                value: rowFilterItemIs,
                itemInArray: true,
              })
            );
          }
        } else {
          const timeout = setTimeout(() => {
            setClickTimeoutState(null);
            // console.log("single clicked");
            handleHeirarchy({
              headerId: groupCurrentValue,
              foundHierachy: groupHierarchy,
              requiredArray: [],
              dispatch: dispatch,
              functionToAddAndUpdate: updateLevel2Properties,
              functionToRemove: removeLevel2Properties,
              Sheetid: Sheetid,
              vizType: vizType,
              functionWillBe: "replaceItemWithpreviousItem",
              groupHierarchy,
              rowHierarchy,
              rowCurrentValue,
              groupCurrentValue,
              rowIsExpandable,
              groupIsExpandable,
            });
            const findRemoveAbleItem = (
              hierarchyArray,
              currentIndex,
              filterArray
            ) => {
              // console.log(currentIndex);
              const heirarchyPreivousItemIs =
                hierarchyArray[currentIndex - 1].uuid;
              // console.log(heirarchyPreivousItemIs);
              const filterItemIs = filterArray.find(
                (filterItem) => filterItem.uuid === heirarchyPreivousItemIs
              );
              // console.log(filterItemIs);
              if (filterItemIs) {
                return filterItemIs;
              }
              return undefined;
            };

            const groupCurrentIndex =
              groupHierarchy?.hierarchyArray.findIndex(
                (row) => row.rename === groupCurrentValue
              ) ?? -1;
            // console.log(groupCurrentIndex);

            const rowCurrentIndex =
              rowHierarchy?.hierarchyArray.findIndex(
                (row) => row.rename === rowCurrentValue
              ) ?? -1;
            // console.log(rowCurrentIndex);

            const groupRemoveAbleItemIs =
              groupCurrentIndex > 0
                ? findRemoveAbleItem(
                    groupHierarchy.hierarchyArray,
                    groupCurrentIndex,
                    filterArray
                  )
                : undefined;

            const rowRemoveAbleItemIs =
              rowCurrentIndex > 0
                ? findRemoveAbleItem(
                    rowHierarchy.hierarchyArray,
                    rowCurrentIndex,
                    filterArray
                  )
                : undefined;

            // console.log(groupRemoveAbleItemIs);
            // console.log(rowRemoveAbleItemIs);

            if (groupIsExpandable && groupRemoveAbleItemIs !== undefined) {
              dispatch(
                removeLevel2Properties({
                  reduxKey: "filters",
                  parentKey: "query",
                  value: groupRemoveAbleItemIs,
                  Sheetid,
                  itemInArray: true,
                })
              );
            }
            if (rowIsExpandable && rowRemoveAbleItemIs !== undefined) {
              // console.log(rowRemoveAbleItemIs);
              dispatch(
                removeLevel2Properties({
                  reduxKey: "filters",
                  parentKey: "query",
                  value: rowRemoveAbleItemIs,
                  Sheetid,
                  itemInArray: true,
                })
              );
            }
          }, 250);
          setClickTimeoutState(timeout);
        }
      } else {
        // console.log(timer);
        if (timer) {
          //it is a second click
          clearTimeout(timer);
          timer = null;
          // console.log("double");
          CalculateAction({
            data: null,
            index: null,
            event,
            requiredArray: rawGroupByKeys,
            hoverIndex,
            dispatch,
            deleteTemporaryFilters,
            setFiltersToOtherSheets,
            Sheetid,
            clickedCaption: null,
            setClickedCaption: null,
            activeIndex: null,
            setActiveIndex: null,
            activeBarIndex,
            setActiveBarIndex,
            vizType,
            rawRowKeys,
            whatShouldDispatch,
            barIndex,
            stackedIndex,
            barClickedValue,
            stackClickedValue,
            stackActiveIndex,
            setStackActiveIndex,
            activeBarIndex,
            setActiveBarIndex,
            clickedValues,
            setClickedValues,
            setWorkbookProperty,
            actionsProperty: getOnDoubleClickProperties,
            workbookId,
            workbookType,
            navigate,
            dataSourceID,
            sheetsArray,
          });
        } else {
          timer = setTimeout(() => {
            // console.log("single");
            CalculateAction({
              data: null,
              index: null,
              event,
              requiredArray: rawGroupByKeys,
              hoverIndex,
              dispatch,
              deleteTemporaryFilters,
              setFiltersToOtherSheets,
              Sheetid,
              clickedCaption: null,
              setClickedCaption: null,
              activeIndex: null,
              setActiveIndex: null,
              activeBarIndex,
              setActiveBarIndex,
              vizType,
              rawRowKeys,
              whatShouldDispatch,
              barIndex,
              stackedIndex,
              barClickedValue,
              stackClickedValue,
              stackActiveIndex,
              setStackActiveIndex,
              activeBarIndex,
              setActiveBarIndex,
              clickedValues,
              setClickedValues,
              setWorkbookProperty,
              actionsProperty: getOnClickProperties,
              workbookId,
              workbookType,
              navigate,
              dataSourceID,
              sheetsArray,
            });
            timer = null;
          }, 300);
          // console.log(timer);
        }
      }
    }
  };

  useEffect(() => {
    // // console.log(Sheetid);
    dispatch(
      setSheetControls({
        Sheetid: Sheetid,
        controls: {
          activeBarIndex,
          stackActiveIndex,
          clickedValues,
        },
      })
    );
  }, [activeBarIndex, stackActiveIndex, clickedValues]);

  const tickFormatter = (tick) => {
    // console.log(SufixPrefix.mode === "Manual");

    if (typeof tick === "number" || typeof tick === "string") {
      const formattedTick =
        typeof tick === "string" ? tick : formatNumber(tick, SufixPrefix);

      // Ensure formattedTick is a string
      const tickAsString = String(formattedTick);
      // console.log(tickAsString);

      // Create a temporary canvas to measure the text width
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      context.font = "12px Arial"; // Use the same font as the chart

      // Handle multi-line ticks (e.g., "Key Growth")
      const lines = tickAsString.split(" "); // Split the tick into words
      // console.log(lines);
      const lineWidths = lines.map((line) => context.measureText(line).width);
      // console.log(lineWidths);

      const totalWidth = Math.max(...lineWidths); // Use the widest line
      // console.log(totalWidth);

      // Adjust the longest label width based on context
      const adjustedMargin = SufixPrefix.mode === "Manual" ? 20 : 10;
      const marginOffset = isTransposeVisible ? 8 : adjustedMargin;
      // console.log(marginOffset);

      setLongestLabelWidth(
        (prevWidth) => Math.max(prevWidth, totalWidth) - marginOffset
      );
      // console.log(tickAsString);

      return tickAsString;
    }

    return tick;
  };

  const handleBarMouseEnter = (lineIndex, stackIndex) => {
    setHoverIndex(lineIndex);
    setStackHoverIndex(stackIndex);
  };

  const handleBarMouseLeave = () => {
    setHoverIndex(null);
  };

  //window resize
  const containerRef = useRef(null);
  const [labelFontSizes, setlabelFontSizes] = useState(labelFontSize);
  // console.log(labelFontSizes);

  useEffect(() => {
    const updateSizes = () => {
      if (!containerRef.current) return;
      const containerWidth = containerRef.current.offsetWidth;
      const containerHeight = containerRef.current.offsetHeight;
      const maxSize = Math.min(containerWidth, containerHeight) / 2 - 10;
      setlabelFontSizes(Math.max(10, Math.min(labelFontSize, maxSize * 0.2)));
    };

    // Run once on mount
    updateSizes();

    // Attach resize event listener
    window.addEventListener("resize", updateSizes);

    // Use ResizeObserver for better performance
    const resizeObserver = new ResizeObserver(updateSizes);
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => {
      window.removeEventListener("resize", updateSizes);
      resizeObserver.disconnect();
    };
  }, [labelFontSize]);

  const { left, top, bottom, right } = stackedBarChartPosition(
    isAxeslabelVisible,
    isTransposeVisible,
    SufixPrefix,
    0,
    0,
    false,
    longestLabelWidth,
    {}
  );
  //YAXIS axes label right and left
  const getYAxisLabelContent = ({ viewBox }, axis) => {
    const { x, y, height } = viewBox;

    const centerY = y + height / 2;

    const centerX =
      axis === "right"
        ? isTransposeVisible
          ? x - 30
          : x + 60
        : isTransposeVisible
        ? 30 // <-- Updated this for left axis when transposed
        : 15; // Default for left axis when not transposed

    let labelText;

    if (axis === "right") {
      // Right Y-axis label
      labelText = isTransposeVisible ? xAxisCaption : ybiaXialCaption;
      // console.log(xAxisCaption, yAxisResponseKey);
    } else {
      // Left Y-axis label
      if (isTransposeVisible) {
        labelText = yAxisResponseKey;
        // console.log(labelText);
      } else {
        if (isRightAxisVisible) {
          // labelText = xAxisCaption || xAxisCaption;
          labelText = xAxisCaption;
          // console.log(yAxisResponseKey, xAxisCaption);
        } else {
          labelText = yAxisResponseKey
            ? ybiaXialCaption
              ? `${xAxisCaption} / ${ybiaXialCaption}`
              : xAxisCaption
            : ybiaXialCaption ?? null;
        }
      }
    }

    return (
      <text
        x={centerX}
        y={centerY}
        textAnchor="middle"
        dominantBaseline={isTransposeVisible ? "middle" : "hanging"}
        fill={labelFontColor}
        style={{
          fontWeight: "normal",
          fontSize: labelFontSizes,
        }}
        transform={`rotate(-90, ${centerX}, ${centerY})`}
      >
        {labelText}
      </text>
    );
  };
  // console.log(transformedTooltipKeys);
  // console.log(sorteData);

  return (
    <div ref={containerRef} style={{ width: "100%", height: "100%" }}>
      <div style={{ width: "100%", height: isTileVisible ? "5%" : "0%" }}>
        {isTileVisible && (
          <div
            className={`w-auto ${isTitleBold ? "font-bold" : ""} ${
              valueAlign === "left"
                ? "text-left"
                : valueAlign === "right"
                ? "text-right"
                : "text-center"
            }`}
            style={{
              fontSize: TitleSize,
              color: TitleFontColor ?? "#bababa",
            }}
          >
            {Title || " Title..."}
          </div>
        )}
      </div>
      <div style={{ width: "100%", height: isTileVisible ? "95%" : "100%" }}>
        <ResponsiveContainer
          width="100%"
          height="100%"
          className="flex items-center justify-center"
        >
          <BarChart
            data={sorteData}
            layout={isTransposeVisible ? "vertical" : "horizontal"}
            margin={{
              left: left,
              bottom,
              top,
              right,
            }}
            onClick={(data, event) => {
              hoverIndex !== null
                ? console.log({
                    clickedValue: data.activeLabel,
                    index: data.activeTooltipIndex,
                  })
                : handleClickEvent({
                    hoverIndex,
                    barClickedValue: data.activeLabel,
                    barIndex: data.activeTooltipIndex,
                    event,
                  });
            }}
          >
            {isGridVisible && <CartesianGrid strokeDasharray="3 3" />}

            <XAxis
              type={isTransposeVisible ? "number" : "category"}
              dataKey={isTransposeVisible ? null : groupByKeys[0]}
              tickFormatter={tickFormatter}
              label={
                isAxeslabelVisible
                  ? {
                      content: ({ viewBox }) => {
                        const { x, y, width, height } = viewBox;

                        const centerX = x + width / 2;
                        // console.log(centerX);

                        // const centerY = y + height / 2;
                        const centerY = calculateYforXaxisLabel({
                          isTransposeVisible,

                          x,
                          y,
                          width,
                          height,
                          isAxeslabelVisible,
                        });
                        // console.log(centerY);
                        // console.log(centerY);

                        return (
                          <>
                            <text
                              x={centerX}
                              y={centerY}
                              textAnchor="middle"
                              dominantBaseline="middle"
                              fill={labelFontColor}
                              style={{
                                fontWeight: "normal",
                                fontSize: labelFontSizes,
                              }}
                              transform={
                                isTransposeVisible
                                  ? null
                                  : `rotate(0, ${centerX}, ${566})`
                              }
                            >
                              {isTransposeVisible
                                ? ybiaXialCaption
                                  ? `${xAxisCaption} / ${ybiaXialCaption}`
                                  : xAxisCaption
                                : yAxisResponseKey}

                              {/* {isTransposeVisible
                            ? xAxisCaption
                            : yAxisResponseKey} */}
                            </text>
                          </>
                        );
                      },
                    }
                  : null
              }
            />

            {/* <XAxis dataKey={isTransposeVisible ? null : groupByKeys[0]} tick={<CustomTick />} /> */}

            <YAxis
              yAxisId="left"
              type={isTransposeVisible ? "category" : "number"}
              dataKey={isTransposeVisible ? groupByKeys[0] : null}
              tickFormatter={tickFormatter}
              label={
                isAxeslabelVisible
                  ? {
                      content: (viewBox) =>
                        getYAxisLabelContent(viewBox, "left"),
                    }
                  : null
              }
            />

            {/* right */}

            {isRightAxisVisible && !isTransposeVisible && (
              <YAxis
                yAxisId="right"
                orientation="right"
                type={isTransposeVisible ? "category" : "number"}
                dataKey={isTransposeVisible ? groupByKeys[0] : null}
                tickFormatter={tickFormatter}
                label={
                  isAxeslabelVisible
                    ? {
                        content: (viewBox) =>
                          getYAxisLabelContent(viewBox, "right"),
                      }
                    : null
                }
              />
            )}

            <Tooltip
              content={
                <CustomTooltip
                  // tooltipKeys={toolTipKeys}
                  toolTipArray={toolTipKeys}
                  SufixPrefix={SufixPrefix}
                  colorSchemeid={colorSchemeid}
                  currentLineIndex={stackHoverIndex}
                  rowKeys={rawRowKeys}
                  headerKeys={uniqueColumnValues}
                  columnKeys={rawGroupByKeys}
                  valueKeys={valueKeys}
                  tooltipKeys={transformedTooltipKeys}
                  chartType={"bar"}
                  mainData={Data}
                  xAxisValue={groupByKeys[0]}
                  dimensionValue={rowKeys[0]}
                  metricVales={valueKeys.map((key) => key.responseKey)}
                  colorMapping={colorMapping}
                />
              }
            />
            {isLegendVisible && (
              <Legend
                iconType="square"
                align={legendAlign.value}
                verticalAlign={legendVerticalAlign.value}
                layout={legendLayout.value}
                fill={legendFontColor}
                legendFontWeight={isLegendBold}
                content={
                  <CustomLegend
                    {...{
                      align: legendAlign.value,
                      verticalAlign: legendVerticalAlign.value,
                      layout: legendLayout.value,
                      valueKeys,
                      legendFontColor,
                      isLegendBold,
                    }}
                  />
                }
              />
            )}
            {uniqueColumnValues.map((item, stackIndex) => {
              // // console.log(item);

              const calculateStackID = () => {
                const arrayOfString = item.split("|");
                // // console.log(arrayOfString);

                return arrayOfString[arrayOfString.length - 1];
              };

              const measureValue = calculateStackID();
              // // console.log(measureValue);

              const calculatedStackId = isStackbarVisible ? measureValue : null;
              const dynamicAxisId = calculateAxis(measureValue, valueKeys);
              // // console.log(valueKeys);

              const { numberFormat } = valueKeys.find(
                (ValueObject) => ValueObject.responseKey === measureValue
              ) || { mode: "Auto" };

              const baseColor =
                colorMapping?.[item] || COLORS[stackIndex % COLORS.length];
              // // console.log("Base Color:", baseColor);
              // // console.log(baseColor, item);

              return (
                <Bar
                  key={stackIndex}
                  dataKey={item}
                  yAxisId={isTransposeVisible ? "left" : dynamicAxisId} // Use the dynamic axisId here
                  fill={baseColor}
                  barSize={barSize}
                  stackId={calculatedStackId}
                  onClick={(data, index, event) => {
                    hoverIndex !== null
                      ? handleClickEvent({
                          hoverIndex,
                          barClickedValue: data[`${groupResponseKey}`],
                          barIndex: hoverIndex,
                          stackedIndex: stackIndex,
                          stackClickedValue: uniqueColumnValues[stackIndex]
                            ? uniqueColumnValues[stackIndex].split("|")[0]
                            : undefined,
                          event,
                        })
                      : console.log({ data });
                  }}
                  onMouseEnter={(data, index) =>
                    handleBarMouseEnter(index, stackIndex)
                  }
                  onMouseLeave={handleBarMouseLeave}
                  background={false}
                  isAnimationActive={isAnimataionOff}
                >
                  {isLabelVisible && (
                    <LabelList
                      dataKey={item}
                      position={labelPosition.value}
                      fontSize={labelFontSize}
                      fill={labelFontColor}
                      stroke={labelFontColor}
                      offset={-55}
                      angle={labelRotate}
                      formatter={(value) => formatNumber(value, numberFormat)}
                    />
                  )}
                  {sorteData.map((e, i) => {
                    const { barClickedCaption, stackClickedCaption } =
                      clickedValues;
                    return (
                      <Cell
                        key={`cell-${i}`}
                        fill={stackBarChartColorArray({
                          activeBarIndex,
                          stackActiveIndex,
                          stackIndex,
                          barClickedCaption,
                          rawGroupByKeys,
                          COLORS,
                          vizType,
                          baseColor,
                          e,
                        })}
                      />
                    );
                  })}
                </Bar>
              );
            })}
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default StackedBarChartComp;
